"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_RiskEvidenceSynthesis_RiskEstimate = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_RiskEvidenceSynthesis_PrecisionEstimate_1 = require("./RTTI_RiskEvidenceSynthesis_PrecisionEstimate");
exports.RTTI_RiskEvidenceSynthesis_RiskEstimate = t.recursion('IRiskEvidenceSynthesis_RiskEstimate', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        value: RTTI_decimal_1.RTTI_decimal,
        _value: RTTI_Element_1.RTTI_Element,
        unitOfMeasure: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        denominatorCount: RTTI_integer_1.RTTI_integer,
        _denominatorCount: RTTI_Element_1.RTTI_Element,
        numeratorCount: RTTI_integer_1.RTTI_integer,
        _numeratorCount: RTTI_Element_1.RTTI_Element,
        precisionEstimate: t.array(RTTI_RiskEvidenceSynthesis_PrecisionEstimate_1.RTTI_RiskEvidenceSynthesis_PrecisionEstimate)
    });
});
//# sourceMappingURL=RTTI_RiskEvidenceSynthesis_RiskEstimate.js.map